module.exports = __webpack_public_path__ + "static/img/1319_phase_function_Paper_PointsHejduk_Prediction.5d572f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1319_phase_function_Paper_PointsHejduk_Prediction.png
// module id = xak+
// module chunks = 0